

const RESUMEN_VENTA = 'ventas/reportes/resumen-ventas'


export  {
    RESUMEN_VENTA
}
